// extracted by mini-css-extract-plugin
module.exports = {"insurance":"Insurance_insurance__1WGOx","title":"Insurance_title__ttpIC","th-td":"Insurance_th-td__3iwlb"};